import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../context/LangContext';
import logo from '../../assets/icons/logowithoutbg.png';

const navContent = {
  en: {
    logo: "",
    menu: [
      { name: "Home", path: "/" },
      { name: "About", path: "/about" },
      { name: "Services", path: "/services" },
      { name: "Cases", path: "/cases" },
      { name: "Blog", path: "/blog" },
      { name: "Contact", path: "/contact" },
      { name: "FAQ", path: "/faq" },
      { name: "Promo", path: "/promo" },
    ],
    booking: "Book Now",
    langSwitch: "中文"
  },
  cn: {
    logo: "",
    menu: [
      { name: "首页", path: "/" },
      { name: "关于我们", path: "/about" },
      { name: "服务项目", path: "/services" },
      { name: "成功案例", path: "/cases" },
      { name: "博客资讯", path: "/blog" },
      { name: "联系我们", path: "/contact" },
      { name: "常见问题", path: "/faq" },
      { name: "特别优惠", path: "/promo" },
    ],
    booking: "立即预约",
    langSwitch: "English"
  }
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { lang, setLang } = useLang();
  const content = navContent[lang];

  return (
    <nav
      className="bg-white/60 backdrop-blur-md border-b border-champagne/60 shadow-soft font-sans"
      style={{
        backgroundImage:
          'linear-gradient(90deg, rgba(255,255,255,0.92) 0px, rgba(255,255,255,0.92) 320px, rgba(235,220,203,0.35) 520px, rgba(246,241,234,0.6) 100%), radial-gradient(600px 300px at 20% 30%, rgba(217,195,169,0.15), rgba(217,195,169,0) 60%), radial-gradient(500px 260px at 70% 60%, rgba(217,195,169,0.12), rgba(217,195,169,0) 55%)',
        backgroundBlendMode: 'soft-light, normal, normal'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-36 items-center py-2">
          {/* Logo with Pearl Gradient Effect */}
          <Link to="/" className="flex items-center">
            <div className="relative mr-3">
              {/* Gold halo behind logo */}
              <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 -inset-x-2 -inset-y-2 translate-x-1 translate-y-1 bg-[radial-gradient(closest-side,rgba(217,195,169,0.35),rgba(217,195,169,0.15)_40%,rgba(217,195,169,0)_70%)] blur-xl"
              />
              <img src={logo} alt="Logo" className="relative h-32 w-32 object-contain" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900">
              {content.logo}
            </h1>
          </Link>
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-4 lg:space-x-6">
            {content.menu.map(item => (
              <Link 
                key={item.path} 
                to={item.path} 
                className={`text-gray-900 hover:text-contrastgreen transition-colors rounded-xl px-2 py-2 hover:drop-shadow whitespace-nowrap ${
                  lang === 'cn' ? 'text-sm' : 'text-base'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/book-form"
              className={`px-3 py-2 rounded-xl shadow-soft transition-all text-gray-900 hover:shadow-glow hover:brightness-110 border border-champagne/60 whitespace-nowrap ${
                lang === 'cn' ? 'text-sm' : 'text-base'
              }`}
              style={{
                backgroundImage:
                  'linear-gradient(90deg, rgba(217,195,169,1) 0%, rgba(217,195,169,0.8) 40%, rgba(217,195,169,0.3) 100%)'
              }}
            >
              {content.booking}
            </Link>
            {/* 语言切换按钮 */}
            <button
              className={`ml-2 px-3 py-2 rounded-xl transition-colors bg-white/60 backdrop-blur-md border border-sage/50 text-gray-900 hover:shadow-glow whitespace-nowrap ${
                lang === 'cn' ? 'text-sm' : 'text-base'
              }`}
              onClick={() => setLang(lang === 'en' ? 'cn' : 'en')}
            >
              {content.langSwitch}
            </button>
          </div>
          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-dark hover:text-green-600 focus:outline-none">
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white/70 backdrop-blur-md border-t border-champagne/60">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {content.menu.map(item => (
              <Link 
                key={item.path} 
                to={item.path} 
                className={`block px-3 py-2 text-gray-900 hover:text-contrastgreen transition-colors rounded-xl hover:drop-shadow whitespace-nowrap ${
                  lang === 'cn' ? 'text-sm' : 'text-base'
                }`}
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/book-form"
              className={`block px-3 py-2 rounded-xl shadow-soft transition-all text-gray-900 hover:shadow-glow hover:brightness-110 border border-champagne/60 whitespace-nowrap ${
                lang === 'cn' ? 'text-sm' : 'text-base'
              }`}
              style={{
                backgroundImage:
                  'linear-gradient(90deg, rgba(217,195,169,1) 0%, rgba(217,195,169,0.8) 40%, rgba(217,195,169,0.3) 100%)'
              }}
              onClick={() => setIsOpen(false)}
            >
              {content.booking}
            </Link>
            <button 
              className={`w-full mt-2 px-3 py-2 rounded-xl transition-colors bg-white/60 backdrop-blur-md border border-sage/50 text-gray-900 hover:shadow-glow whitespace-nowrap ${
                lang === 'cn' ? 'text-sm' : 'text-base'
              }`}
              onClick={() => setLang(lang === 'en' ? 'cn' : 'en')}
            >
              {content.langSwitch}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;